import React, { useEffect, useState } from "react";
import Header from "./Header";
import "bootstrap/dist/css/bootstrap.min.css";
import host from "../config";
const UserBlockedData = () => {
  const [bookings, setBookings] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const bookingsPerPage = 5; // Number of records per page

  // Fetch bookings from API
  useEffect(() => {
    fetch(`${host}/getManualBookingDetails`) // Update URL if different
      .then((response) => response.json())
      .then((data) => {
        if (data.data) {
          setBookings(data.data);
        } else {
          setBookings([]);
        }
      })
      .catch((error) => console.error("Error fetching bookings:", error));
  }, []);

  // Calculate pagination
  const indexOfLastBooking = currentPage * bookingsPerPage;
  const indexOfFirstBooking = indexOfLastBooking - bookingsPerPage;
  const currentBookings = bookings.slice(
    indexOfFirstBooking,
    indexOfLastBooking
  );

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <Header />
      <div className="container mt-4">
        <h2 className="mb-3">Manual Bookings</h2>
        <table className="table table-striped table-hover">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Venue Name</th>
              <th>Slot Type</th>
              <th>Category</th>
              <th>Booking Date</th>
              <th>Person Name</th>
              <th>Contact No</th>
              <th>Email</th>
              <th>Amount</th>
              <th>Payment Status</th>
              <th>Cancel Status</th>
            </tr>
          </thead>
          <tbody>
            {currentBookings.map((booking, index) => (
              <tr key={booking.sno}>
                <td>{indexOfFirstBooking + index + 1}</td>
                <td>{booking.venue_name}</td>
                <td>{booking.slot_type}</td>
                <td>{booking.category}</td>
                <td>{new Date(booking.booking_date).toLocaleDateString()}</td>
                <td>{booking.person_name}</td>
                <td>{booking.contact_no}</td>
                <td>{booking.mail_id}</td>
                <td>{booking.amount ? `₹${booking.amount.toFixed(2)}` : ""}</td>
                <td>{booking.amount_status}</td>
                <td>{booking.cancel_status}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Pagination */}
        <nav>
          <ul className="pagination justify-content-center">
            {Array.from(
              { length: Math.ceil(bookings.length / bookingsPerPage) },
              (_, index) => (
                <li
                  key={index}
                  className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => paginate(index + 1)}
                  >
                    {index + 1}
                  </button>
                </li>
              )
            )}
          </ul>
        </nav>
      </div>
    </>
  );
};

export default UserBlockedData;
